import styled from 'styled-components';

interface CursorInterface {
    kind?: string;
}

const Cursor = styled.span<CursorInterface>`
    cursor: ${props =>  props.kind ? props.kind : 'pointer'};
`;

export default Cursor;